import { createContext, useContext, useEffect, useMemo, useState } from "react";
import query from "../server/constants.api";
import useFetch from "../server/useFetch";
import { useGlobalFilterContext } from "./GlobalFilterProvider";

const GlobalDataContext = createContext();

export const useGlobalData = () => {
    return useContext(GlobalDataContext);
};

export const GlobalDataProvider = ({ children }) => {
    const { subEntity } = useGlobalFilterContext();

    // Create Incidents
    const [cityService, setCityService] = useState(null);
    // 3D Object
    const [objectFor3D, setObjectFor3D] = useState(null);
    const [is3DButtonsDisabled, setIs3DButtonsDisabled] = useState(false);

    /**
     * Api to call incidents properties for create incident modal
     */
    const {
        data: incidentPropertiesData,
        isFetching: isFetchingIncidentProperties,
        refetch: refetchIncidentProperties,
    } = useFetch(
        query.path.getIncidentProperties,
        "getIncidentProperties",
        {
            tenant: subEntity?.tenant,
        },
        false,
        "GET",
        query.middlewareCommandURL
    );

    /**
     * Api to call generic services for city services, when clicking in the map 
     */
    const {
        data: genericItemsData,
        isFetching: isFetchingGenericItems,
        refetch: refetchGenericItems,
    } = useFetch(
        query.path.getItems,
        "getGenericItemsForIncident",
        {
            tenant: subEntity?.tenant,
            generic: true,
        },
        false,
        "GET",
        query.middlewareURL
    )

    /**
     * Api to call incident categories for create incident modal
     * For the MiCo case, does not change the result
     * So we send the class as MiCo, is indifferent 
     */
    const {
        data: incidentCategoriesData,
        isFetching: isFetchingIncidentCategories,
        refetch: refetchIncidentCategories,
    } = useFetch(
        query.path.getIncidentCategories,
        "getIncidentCategories",
        {
            tenant: cityService?.tenant,
            class: cityService?.class
        },
        false,
        "GET",
        query.middlewareCommandURL
    );

    /**
     * UseEffect to refetch incident properties and generic items when tenant changes
     */
    useEffect(() => {
        if (subEntity?.tenant) {
            refetchIncidentProperties();
            refetchGenericItems();
        }
    }, [subEntity?.tenant]);

    useEffect(() => {
        if (cityService) {
            refetchIncidentCategories();
        }
    }, [cityService]);

    const contextValue = useMemo(() => ({
        incidentPropertiesData, isFetchingIncidentProperties, genericItemsData, isFetchingGenericItems,
        incidentCategoriesData, isFetchingIncidentCategories, cityService, setCityService,
        objectFor3D, setObjectFor3D,
        is3DButtonsDisabled, setIs3DButtonsDisabled

    }), [incidentPropertiesData, isFetchingIncidentProperties, genericItemsData,
        isFetchingGenericItems, incidentCategoriesData, isFetchingIncidentCategories, cityService, setCityService,
        objectFor3D, setObjectFor3D,
        is3DButtonsDisabled, setIs3DButtonsDisabled
    ]);

    return (
        <GlobalDataContext.Provider value={contextValue}>
            {children}
        </GlobalDataContext.Provider>
    );
};